import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SanitizerPipe } from '../../pipes/sanitizer.pipe';
import { ImageByFacilityComponent } from '../image-by-facility/image-by-facility.component';
import { LogoFacilityComponent } from '../logo-facility/logo.component';
import { FooterAccordionComponent } from './footer-accordion/footer-accordion.component';
import { FooterElementComponent } from './footer-element/footer-element.component';
import { FooterLogoComponent } from './footer-logo/footer-logo.component';
import { FooterTableComponent } from './footer-table/footer-table.component';
import { FooterTitleComponent } from './footer-title/footer-title.component';
import { FooterComponent } from './footer.component';

@NgModule({
    imports: [
        CommonModule,
        NgOptimizedImage,
        SanitizerPipe,
        LogoFacilityComponent,
        ClipboardModule,
        MatTooltipModule,
        MatExpansionModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        ImageByFacilityComponent,
    ],
    declarations: [
        FooterComponent,
        FooterTitleComponent,
        FooterTableComponent,
        FooterElementComponent,
        FooterLogoComponent,
        FooterAccordionComponent,
    ],
    exports: [
        FooterComponent,
        FooterTitleComponent,
        FooterTableComponent,
        FooterElementComponent,
        FooterLogoComponent,
        FooterAccordionComponent,
    ],
})
export class FooterModule {}
